import React,{useEffect} from "react";
import Box from '@mui/material/Box';
import {SaveAnswers} from "../services/Service"
import Typography from '@mui/material/Typography';
import Helpers from "../utility/Helpers"
import Footer from './../common/Footer';
import Slider from '@mui/material/Slider';
import { useNavigate } from 'react-router-dom';
import NavigationMenu from '../NavigationMenu';
import {GetQuestions} from "../services/Service"
import Loader from './../common/Loader'
import {
    Chart as ChartJS,
    RadialLinearScale,
    ArcElement,
    Tooltip,
    Legend,
  } from 'chart.js';
ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend);

function Survey(props) {
  const navigate=useNavigate();
    const [index, setIndex] = React.useState(0);
    const [score, setScore] = React.useState(0);
    const [questionScores, setQuestionScores] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);

    const backgroundPictures = [
        "physical-health-image.png",
        "mental-health-image.png",
        "family-image.png",
        "social-relationship-image.png",
        "fulfilment-image.png",
        "environment-image.png",
        "career-business-aspiration-image.png",
        "financial-status-image.png",
        "decision-making-image.png",
        "sustainability-image.png"
      ];

  const marks = [
    {value: 0, label: '0', },
    {value: 1, label: '1', },
    { value: 2, label: '2', },
    { value: 3, label: '3', },
    { value: 4, label: '4', },
    { value: 5, label: '5', },
    { value: 6, label: '6', },
    { value: 7, label: '7', },
    { value: 8, label: '8', },
    { value: 9, label: '9', },
    { value: 10, label: '10', },
  ];

    
    useEffect(() => {
        if(questionScores.length<1){
            if(sessionStorage.getItem('questionData')===null){
              GetQuestions().then((qres) => {
                sessionStorage.setItem("questionData",JSON.stringify(qres.data));
              }).catch((error) => {Helpers.handleError(error);});
            }
            else{
              let qsns=JSON.parse(sessionStorage.getItem('questionData'));
              setQuestionScores(qsns);
            }
            setIndex(0);
            setScore(0);
        }
      }, [questionScores, index]);

    const valuetext = (value) =>{
      return `${value}`;
    }
    const handleSliderChange = (newValue) => {

      questionScores[index].scored=newValue.target.value;
      setQuestionScores(questionScores);
      setScore(newValue.target.value);
      colorLabel(index);
    };
    const colorLabel = (inx) =>{
      if((inx)===2 || (inx)===3){
            if(process.env.NODE_ENV==='production'){
              setTimeout(function(){ 
                let LabelsBuild = document.getElementsByClassName("css-goitey");
                  for (var bi = 0; bi < LabelsBuild.length; bi++) {
                    LabelsBuild[bi].classList.add('css-Label-black');
                  }
                  let LabelsBuild2 = document.getElementsByClassName("css-mcxtpx");
                  for (var bj = 0; bj < LabelsBuild2.length; bj++) {
                    LabelsBuild2[bj].classList.add('css-Label-black');
                  }
                  let LabelsBuild3 = document.getElementsByClassName("MuiSlider-markLabel");
                  for (var bk = 0; bk < LabelsBuild3.length; bk++) {
                    LabelsBuild3[bj].classList.add('css-Label-black');
                  }
                  
                  },200);
                }
            else{
            setTimeout(function(){ 
              let labelElements = document.getElementsByClassName("css-1ucwjgd-MuiSlider-markLabel");
                for (var i = 0; i < labelElements.length; i++) {
                  labelElements[i].classList.add('css-Label-black');
                }
                let labelElements2 = document.getElementsByClassName("css-1bvr8oc-MuiSlider-markLabel");
                for (var j = 0; j < labelElements2.length; j++) {
                  labelElements2[j].classList.add('css-Label-black');
                }

              },200);
            }
          }
          else{
                if(process.env.NODE_ENV==='production'){
                    let LabelsBuild = document.getElementsByClassName("css-goitey");
                    for (var b = 0; b < LabelsBuild.length; b++) {
                      LabelsBuild[b].classList.remove('css-Label-black');
                    }
                    let LabelsBuild2 = document.getElementsByClassName("css-mcxtpx");
                      for (var j = 0; j < LabelsBuild2.length; j++) {
                        LabelsBuild2[j].classList.remove('css-Label-black');
                      }
                      let LabelsBuild3 = document.getElementsByClassName("MuiSlider-markLabel");
                      for (var k = 0; k < LabelsBuild3.length; k++) {
                        LabelsBuild3[k].classList.remove('css-Label-black');
                      }
                }
                let labelElements = document.getElementsByClassName("css-1ucwjgd-MuiSlider-markLabel");
                for (var m = 0; m < labelElements.length; m++) {
                  labelElements[m].classList.remove('css-Label-black');
                }
                let labelElements2 = document.getElementsByClassName("css-1bvr8oc-MuiSlider-markLabel");
                for (var n = 0; n < labelElements2.length; n++) {
                  labelElements2[n].classList.remove('css-Label-black');
                }
                let labelElements3 = document.getElementsByClassName("MuiSlider-markLabelActive");
                for (var l = 0; l < labelElements3.length; l++) {
                  labelElements3[l].classList.remove('css-Label-black');
                }
      }
    }
    const nextQuestion =() =>{
      if(score>0){
        if(index<9){
            setIndex(index+1);
            colorLabel(index+1);
            setScore(0);
            window.scrollTo(0, 0);
        }
        if(index===9){ //final page
          completeSurvey();
        }
      }
      else{
        Helpers.handleError("Please select a value (other than 0) to move to the next question");
      }
        
    };
    const completeSurvey= async ()=>{
      setIsLoading(true);
      await SaveAnswers(questionScores).then((res) => {
        Helpers.handleSuccess(res.message);
        sessionStorage.setItem("wheelsessionid",res.data);
        setIsLoading(false);
        navigate("/surveythankyou");
        return;
      }).catch((error) => {Helpers.handleError(error); setIsLoading(false);});
    };

    return(<>
        <Box  width='100%'
        display='flex'
        justifyContent='center'>
            <NavigationMenu pageName={"Survey"}/>
          <Box className="pageContainer2" width='100%'>
            <Box width='100%' sx={{backgroundColor:questionScores[index]!==undefined? questionScores[index].colorCode : "#fff"}}> 
              <Box className="text-Section">
                <Typography sx={{fontWeight:'500', fontSize:'18px', textTransform: 'uppercase', fontFamily: 'Quicksand', paddingTop:'20px'}}>{questionScores[index]!==undefined?questionScores[index].categoryName:""}</Typography>
                <Typography sx={{fontWeight:'500', fontSize:'24px', textTransform: 'uppercase', fontFamily: 'Quicksand', paddingBottom:'5px', minHeight:'100px', paddingRight:'10px'}}>
                {questionScores[index]!==undefined?questionScores[index].questionText:""}
                </Typography>
                <Typography sx={{fontWeight:'500', fontSize:'18px', fontFamily: 'Quicksand', paddingRight:'10px'}}>
                {questionScores[index]!==undefined?questionScores[index].extraText:""}
                </Typography>
                <Typography sx={{fontWeight:'500', fontSize:'18px', fontFamily: 'Quicksand', paddingTop:'5px', paddingRight:'10px'}}>
                {questionScores[index]!==undefined?questionScores[index].scoreGuide:""}
                </Typography>
                </Box>

                   <Box width='100%' paddingBottom='30px'></Box>
                  <Box paddingBottom='30px'
                    width='100%'
                    display='flex'
                    justifyContent='center'
                    >
                      <Box
                    width='80%'
                    display='flex'
                    justifyContent='center'
                    >
                        <Box component="img"
                        sx={{display: "flex",justifyContent: "space-between", width:'300px', paddingLeft:'20px',paddingRight:'20px'}}
                      alt="Org Image"
                      src={process.env.PUBLIC_URL + "/images/"+backgroundPictures[index]} />
                      </Box>
                  </Box>


                  <Box sx={{ width: '100%', display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center' }}>

                    <Slider sx={{width: '85%'}}
                      aria-label="Always visible"
                      //defaultValue={score}
                     getAriaValueText={valuetext}
                      valueLabelDisplay="auto"
                      shiftStep={1}
                      step={1}
                      value={score}
                      marks={marks}
                      min={0}
                      max={10}
                      color="secondary"
                      onChange={handleSliderChange}
                    />
                </Box>


                <Box
                            width='100%'
                            display='flex'
                            justifyContent='center'
                            sx={{paddingTop:'15px', paddingBottom:'10px'}}
                            >
                            <Box component="img"
                            justifyContent='center'
                                sx={{ paddingLeft:'20px',paddingRight:'20px', width:'100%', maxWidth:'400px'}}
                                alt="Org Image"
                                src={process.env.PUBLIC_URL + "/images/next-button.png"}
                                onClick={()=>{
                                    nextQuestion()
                                    }}
                            />
                        </Box>
                        <Box
                            width='100%'
                            display='flex'
                            justifyContent='center'
                            sx={{paddingTop:'10px', paddingBottom:'10px'}}>
                            <Typography sx={{fontWeight:'500', fontSize:'18px', color:'white'}}>
                                Question {index+1} of 10
                            </Typography>
                        </Box>
              </Box>
              <Box
                    width='100%'
                    sx={{ paddingLeft:'20px', paddingRight:'20px'}}
                    >
                  
                  
                    
              
              </Box>

              <Footer />
            </Box>
            
        </Box>
        <Loader isLoading={isLoading}/>
        
        </>
    );
}
export default Survey;